import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlCityListRequest } from "../../models/service-models/city/CityListRequest";
import { CityService } from "../../services/CityService";
import { mdlLanguage } from "../../models/ui-models/Language";

export type CitySelectProps = {
    countryId?: string;
    selectedLanguage?: mdlLanguage;
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
}


export const CitySelect = (props: CitySelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        refetch();
    }, [props.countryId]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getCities", props.countryId],
        () => {
            if (props.countryId) {
                var request: mdlCityListRequest = { pageSize: 0, countryId: props.countryId, currentLanguage: props.selectedLanguage?.value };
                return CityService.List(request);
            }

        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.countryId
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let cities = data?.body?.data;

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                size="middle"
                onFocus={onFocus}
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseCity")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={cities?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}